import React from "react";
import toast from "react-hot-toast";
import { deleteCourier, getCouriers } from "api/CourierAPI";
import { ICourier } from "../types/courier.interface";
import { useLocation, useNavigate } from "react-router-dom";

const useCourierTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [couriers, setCouriers] = React.useState<ICourier[]>([]);

  const getCourierTableData = async () => {
    try {
      const response = await getCouriers();
      setCouriers(response.data.data);
    } catch (error) {
      toast.error("Gagal mengambil data kurir");
    }
  };

  const handleDeleteCourier = async (id: number) => {
    try {
      await deleteCourier(id);
      getCourierTableData();
      toast.success("Berhasil menghapus kurir");

      if (location.pathname.includes(`/admin/couriers/${id}`))
        navigate("/admin/couriers");
    } catch (error) {
      toast.error("Gagal menghapus kurir");
    }
  };

  const handleOpenDetail = (props: ICourier) =>
    navigate(`/admin/couriers/${props.id}`);

  const handleRedirectUpdate = (props: ICourier) =>
    navigate(`/admin/couriers/edit/${props.id}`);

  return {
    couriers,
    getCourierTableData,
    handleDeleteCourier,
    handleOpenDetail,
    handleRedirectUpdate,
  };
};

export default useCourierTable;
